// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const healthDetails = {
  health_details_section: {
    name: 'Health Details Section (DEFAULT DO NOT CHANGE)',
    previous_page_button_text: '所有健康计划',
    eligibility_notice: {
      name: '[DEFAULT] Eligibility Notice',
      button_text: '了解更多',
      hsa: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '此计划',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '符合HSA资格',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hsa_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '如果您选择此符合HSA资格的健康计划,您的雇主将向您的HSA账户贡献最高**',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '**。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hsa_match: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '如果您选择此符合HSA资格的健康计划,您的雇主将',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '匹配您缴款的',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '%',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '(最高**',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '**)。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hra: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '此计划',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '符合HRA资格',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hra_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '如果您选择此符合 HRA 资格的健康计划,您的雇主将向您的 HRA ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '缴纳最高 ',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      fsa: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '此计划',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '符合 FSA 资格',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      fsa_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '如果您选择此符合FSA资格的健康计划,您的雇主将向您的FSA账户贡献最高**',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '**。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      sihra: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '此计划',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '符合 SIHRA 资格',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      sihra_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '如果您选择此计划,您的雇主将向您的 SIHRA ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '最多',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '贡献 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      no_reimburse_copay: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: 'HRA不涵盖共付额报销。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    plan_eligibility: {
      title: '符合条件',
      subtitle: '此计划',
      buttonText: '了解更多',
    },
    plan_details: {
      name: '[DEFAULT] Plan Details',
      plan_essentials_card_title: '计划要点',
      prescriptions_card_title: '处方',
      doctor_visits_card_title: '就诊记录',
      breakdown_tag_tier1_deductible: '第1级',
      breakdown_tag_tier2_deductible: '第二层级',
      prescription_cost_not_covered_text: '不包括',
      doctors_providers_card_title: '医生和医疗服务提供者',
    },
    cta_pdf_header_text: '想要了解所有计划详情?',
    cta_provider_header_text: '我的医生或网络内医疗服务提供者是否可用?',
    after_deductible: '满足免赔额后',
    rx_tiers_static_values: {
      retail: '零售(30天供应量)',
      rx_tiers: {
        tier_1: '第1级处方药',
        tier_2: '第2级处方药',
        tier_3: '第3级处方药',
        tier_4: '第4级处方药',
        tier_5: '第5级处方药',
      },
      mail_order: '邮购(90天供应量)',
      no_coverage: '不承保',
      retail_text: '零售',
      mail_order_text: '邮购',
      after_deductible: '自付额后',
      coverage_heading: '处方药承保范围',
      deductible_waived: '免除自付额',
    },
    rx_copay: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您支付 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' 共付额',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    rx_coinsurance: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance_with_limits_having_min_max: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' (minimum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ', maximum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance_with_limits_without_min: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您支付 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '(最高限额:',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    rx_coinsurance_with_limits_without_max: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您支付 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '(最低限额:',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    rx_copay_then_coinsurance: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您支付 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' 共付额,然后您支付 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
  },
};
